<template>
  <div id="chatAdminInput">
    <div id="chatAdminSettingMenu">
      <select v-model="adminTargetChatSite" id="adminTargetChatSite">
        <option value="">전체</option>
        <option value="localhost">스포츠</option>
        <option value="racing">미니게임</option>
        <option value="lottery">파워볼</option>
        <option value="fxgame">FX게임</option>
      </select>
    </div>
    <input type="text" v-model="inputValue"
      id="chatAdminInputArea"
      placeholder=""
      @keypress.enter="printAdminMessage"
      @click="scrollBottom" />
    <button id="chatAdminInputButton" @click="printAdminMessage" />
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      'inputValue': '',
      'adminTargetChatSite': ''
    }
  },
  methods: {
    scrollBottom () {
      let screen = document.getElementById('chatMessageList')
      screen.scrollTop = screen.scrollHeight
    },
    printAdminMessage (event, message) {
      // console.log('printAdminMessage', this)

      // 도배금지 체크
      if (!is_login) { // eslint-disable-line
        return false
      }
      let chatInputArea = this.inputValue
      this.inputValue = ''
      if (chatInputArea.length < 1) {
        return false
      }

      if (chatInputArea !== '') {
        // send message to server
        var messageProtocol = {
          'cmd': 'ADMIN',
          'op_cmd': 'MSG',
          'target_site_id': adminTargetChatSite.value, // eslint-disable-line no-undef
          'msg': chatInputArea,
          'userid': userid, // eslint-disable-line no-undef
          'username': username // eslint-disable-line no-undef
        }
        // send message to server
        window.sendToLobby(messageProtocol) // eslint-disable-line no-undef
      }
    }
  }
}
</script>

<style lang="scss">
#chatAdminInput {
  position: fixed;
  bottom: 50px;
  width: 100%;
  letter-spacing: -5px;
  #chatAdminSettingMenu {
    position: absolute;
    left: 0;
    width: 70px;
    height: 31px;
    overflow: visible;
    display: inline-block;
    #adminTargetChatSite {
      position: absolute;
      width: 70px;
      height: 31px;
      line-height: 31px;
      border: 1px solid #ebeef3;
      border-left: 0;
    }
  }
  #chatAdminInputArea {
    width: 100%;
    height: 31px;
    padding: 0 30px 0 70px;
    border: 1px solid #ebeef3;
  }

  #chatAdminInputButton {
    position: absolute;
    right: 0;
    bottom: 0;
    border: 0;
    font-size: 25px;
    height: 31px;
    width: 32px;
    background: url("/nlivechat/img/sp_chat.png") no-repeat -240px -240px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// chat-inputAdmin.vue?200fa672